import React, { useState } from "react";
import style from "./style.module.scss";
import Dropzone from "react-dropzone";
import Modal from "../../../../../components/modal";
import Select from "../../../../../components/form/select";
import Button from "../../../../../components/new-button";
import FileIcon from "../../../../../assets/svg/icons/common/file";
import UploadIcon from "../../../../../assets/svg/icons/common/upload";
import CloseIcon from "../../../../../assets/svg/icons/common/CloseIcon";
import { UploadPaylianceDocumentApi } from "../../../../../../api";
import toast from "react-hot-toast";
import { PAYLIANCE_FILE_TYPE_OPTIONS } from "../../../../../../constants";

function UploadPaylianceDocument({ isOpen, onClose, historyId }) {
  const [fileType, setFileType] = useState("");
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetAndClose = () => {
    setFileType("");
    setFile(null);
    onClose();
  };

  const handleSubmit = () => {
    if (!fileType) {
      toast.error("Please choose a file type");
      return;
    }
    if (!file) {
      toast.error("Please select a file to upload");
      return;
    }

    const formData = new FormData();
    formData.append("id", historyId);
    formData.append("fileType", fileType);
    formData.append("file", file, file.name);

    setIsSubmitting(true);
    const toastId = toast.loading("Uploading document to Payliance...", {
      duration: 30 * 1000,
    });

    UploadPaylianceDocumentApi(formData)
      .then((res) => {
        if (res.status) {
          toast.success(res.message || "Document uploaded successfully", {
            id: toastId,
            duration: 5 * 1000,
          });
          resetAndClose();
        } else {
          toast.error(res.message || "Something went wrong", {
            id: toastId,
            duration: 10 * 1000,
          });
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Failed to upload document",
          { id: toastId, duration: 10 * 1000 },
        );
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={resetAndClose} header="" size="md">
      <div className={style.container}>
        <h5 className={style.title}>Upload Document to Payliance</h5>

        <div className={style.content}>
          <Select
            label="File Type"
            placeholder="Select file type"
            options={PAYLIANCE_FILE_TYPE_OPTIONS}
            value={fileType}
            onChange={(value) => setFileType(value)}
          />

          <div className={style.fileField}>
            <label className={style.fileLabel}>File</label>

            {file ? (
              <div className={style.selectedFile}>
                <div className={style.selectedFileInfo}>
                  <FileIcon />
                  <span className={style.selectedFileName}>{file.name}</span>
                </div>
                <button
                  type="button"
                  className={style.removeFile}
                  onClick={() => setFile(null)}
                  aria-label="Remove file"
                >
                  <CloseIcon />
                </button>
              </div>
            ) : (
              <Dropzone
                multiple={false}
                onDrop={(accepted) => setFile(accepted?.[0] || null)}
                maxSize={1000000 * 200}
                accept=".pdf,.jpeg,.jpg,.png,.doc,.docx,.xls,.xlsx"
              >
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <div
                    {...getRootProps()}
                    className={`${style.dnd} ${isDragActive ? style.dndActive : ""}`}
                  >
                    <input {...getInputProps()} />
                    <div className={style.inner_content}>
                      <UploadIcon />
                      <div>
                        <p className={style.uploadText}>
                          Upload document by drag and drop or{" "}
                          <span>click to upload</span>
                        </p>
                        <p className={style.hint}>pdf, jpg, png, doc, xls</p>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}
          </div>
        </div>

        <div className={style.footer}>
          <Button variant="ghost" onClick={resetAndClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
            isLoading={isSubmitting}
          >
            Upload
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default UploadPaylianceDocument;
